import { Control, Controller, FieldArrayWithId, UseFieldArrayAppend, UseFieldArrayRemove, UseFormReturn } from "react-hook-form";

import { BaseButton, BaseInput, BaseSelect } from "src/components";
import BaseSectionTitle from "src/components/layout/BaseSectionTitle";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import SpaceBaseTable from "src/pages/product/forms/commonSpaceForm/components/SpaceBaseTable";
import { useModal } from "src/recoil/modalState/hook";
import { BULLET, INVALID_PHONE_NUMBER_MESSAGE, validateEmail, validateMobileNumber } from "src/utils";
import * as xlsx from "xlsx";

import clsx from "clsx";
import { useState } from "react";
import { Row } from "react-table";
import ExcelUploadModal from "src/pages/user/form/ExcelUploadModal";
import { defaultUserValue, UserFormData } from "./UserForm";

export interface UserCellProps {
  row: Row<FieldArrayWithId<UserFormData, "users", "id">>;
  control: Control<UserFormData>;
  useFormReturn: UseFormReturn<UserFormData>;
  remove: UseFieldArrayRemove;
  formUserList: FieldArrayWithId<UserFormData, "users", "id">[];
}

export const userAddColumns: any[] = [
  {
    Header: "No.",
    accessor: "no",
    width: 60,
    Cell: ({ row, control, useFormReturn }: UserCellProps) => {
      const {
        formState: { errors },
      } = useFormReturn;

      return (
        <div key={row.original.id}>
          {row.index + 1}
          {errors?.users?.[row.index] && <p className="validation-text h20"></p>}
        </div>
      );
    },
  },

  {
    Header: <p className="required">이용자 연락처 및 이메일</p>,
    accessor: "inviteMobileNumber",
    width: 320,
    Cell: ({ row, control, useFormReturn }: UserCellProps) => {
      const {
        formState: { errors },
        watch,
      } = useFormReturn;
      const emailValue = watch(`users.${row.index}.inviteEmail`);
      const invitationType = watch(`users.${row.index}.invitationType`);
      const [isFocusList, setIsFocusList] = useState<{ index: number; isFocus: boolean }>({ index: 0, isFocus: false });

      return (
        <div key={row.original.id} className={`base-select-input ${isFocusList.isFocus ? "base-select-input__focus" : ""} minmax280`}>
          <Controller
            control={control}
            name={`users.${row.index}.invitationType`}
            rules={{ required: true }}
            render={({ field }) => {
              return (
                <BaseSelect
                  menuPlacement="auto"
                  value={field.value ?? "phone"}
                  placeholder="초대방법"
                  stateOptions={[
                    {
                      value: "phone",
                      label: "휴대폰",
                    },
                    {
                      value: "email",
                      label: "이메일",
                    },
                  ]}
                  setStateValue={(value: string) => {
                    field.onChange(value);
                  }}
                  onFocus={() =>
                    setIsFocusList({
                      index: row.index,
                      isFocus: true,
                    })
                  }
                  onBlur={() =>
                    setIsFocusList({
                      index: row.index,
                      isFocus: false,
                    })
                  }
                />
              );
            }}
          />
          {invitationType === "phone" ? (
            <Controller
              control={control}
              rules={{
                validate: (value) => {
                  // 빈값 검증
                  if (!value) {
                    return "필수입력 항목입니다.";
                  }

                  // 휴대폰 번호가 입력된 경우 형식 검증
                  if (validateMobileNumber(value) !== true) {
                    return INVALID_PHONE_NUMBER_MESSAGE;
                  }
                  return true;
                },
              }}
              name={`users.${row.index}.inviteMobileNumber`}
              render={({ field }) => (
                <div>
                  <BaseInput
                    name={`inviteMobileNumber`}
                    type="phone"
                    placeholder="연락처를 입력해주세요"
                    className="minmax180"
                    value={field.value}
                    onChange={field.onChange}
                    onFocus={() =>
                      setIsFocusList({
                        index: row.index,
                        isFocus: true,
                      })
                    }
                    onBlur={() =>
                      setIsFocusList({
                        index: row.index,
                        isFocus: false,
                      })
                    }
                  />

                  {errors?.users?.[row.index] && <p className="validation-text h20">{errors?.users?.[row.index]?.inviteMobileNumber?.message}</p>}
                </div>
              )}
            />
          ) : (
            <Controller
              control={control}
              rules={{
                validate: (value) => {
                  // 빈값 검증
                  if (!value) {
                    return "필수입력 항목입니다.";
                  }
                  // 이메일이 입력된 경우 형식 검증
                  if (value && !validateEmail(value)) {
                    return "이메일 주소를 확인해주세요.";
                  }
                  return true;
                },
              }}
              name={`users.${row.index}.inviteEmail`}
              render={({ field }) => (
                <div className="">
                  <BaseInput
                    name={`inviteEmail`}
                    placeholder="이메일을 입력해주세요"
                    value={field.value}
                    onChange={field.onChange}
                    className="minmax180"
                    onFocus={() =>
                      setIsFocusList({
                        index: row.index,
                        isFocus: true,
                      })
                    }
                    onBlur={() =>
                      setIsFocusList({
                        index: row.index,
                        isFocus: false,
                      })
                    }
                  />
                  {errors?.users?.[row.index] && <p className="validation-text h20">{errors?.users?.[row.index]?.inviteEmail?.message}</p>}
                </div>
              )}
            />
          )}
        </div>
      );
    },
  },
  // {
  //   Header: <p className="w-100 text-center">이메일 주소</p>,
  //   accessor: "inviteEmail",
  //   width: 320,
  //   Cell: ({ row, control, useFormReturn }: UserCellProps) => {
  //     const {
  //       formState: { errors },
  //       watch,
  //     } = useFormReturn;
  //     const mobileValue = watch(`users.${row.index}.inviteMobileNumber`);

  //     return (
  //       <div key={row.original.id} className="w-100 d-flex flex-center-center">
  //         <Controller
  //           control={control}
  //           rules={{
  //             validate: (value) => {
  //               // 둘 다 비어있는 경우
  //               if (!value && !mobileValue) {
  //                 return "둘 중 하나는 필수입니다.";
  //               }
  //               // 둘 다 입력된 경우
  //               if (value && mobileValue) {
  //                 return "둘 중 하나만 입력 가능합니다.";
  //               }
  //               // 이메일이 입력된 경우 형식 검증
  //               if (value && !validateEmail(value)) {
  //                 return "이메일 주소를 확인해주세요.";
  //               }
  //               return true;
  //             },
  //           }}
  //           name={`users.${row.index}.inviteEmail`}
  //           render={({ field }) => (
  //             <div className="d-flex flex-start-center flex-column">
  //               <BaseInput
  //                 name={`inviteEmail`}
  //                 placeholder="이메일을 입력해주세요"
  //                 className="minmax240"
  //                 value={field.value}
  //                 onChange={field.onChange}
  //               />
  //               {errors?.users?.[row.index] && <p className="validation-text h20">{errors?.users?.[row.index]?.inviteEmail?.message}</p>}
  //             </div>
  //           )}
  //         />
  //       </div>
  //     );
  //   },
  // },

  {
    Header: "삭제",
    accessor: "delete",
    width: 48,
    Cell: ({ row, remove, useFormReturn }: UserCellProps) => {
      const {
        formState: { errors },
      } = useFormReturn;

      return (
        <div key={row.original.id}>
          <button className="base-trash-btn color-gray" onClick={() => remove(row.index)} type="button" />
          {errors?.users?.[row.index] && <p className="validation-text h20"></p>}
        </div>
      );
    },
  },
];

// 이용자 정보를 관리하는 컴포넌트
const UserInfo = ({
  control, // react-hook-form의 control 객체
  formUserList, // 이용자 정보 리스트
  append, // 이용자 정보 추가 함수
  remove, // 이용자 정보 삭제 함수
  useFormReturn, // react-hook-form의 form 객체
}: {
  control: Control<UserFormData>;
  formUserList: FieldArrayWithId<UserFormData, "users", "id">[];
  append: UseFieldArrayAppend<UserFormData, "users">;
  remove: UseFieldArrayRemove;
  useFormReturn: UseFormReturn<UserFormData>;
}) => {
  // 모달 상태 관리
  const { setBaseModal, setAbstractModalZ1 } = useModal();
  // 파트너 권한 확인
  const { isAuthority } = usePartnerAuthority();

  // 이용자 추가 버튼 클릭 핸들러
  const handleClickAddButton = () => {
    append(defaultUserValue);
  };

  /**
   *  모달에서 사용할 엑셀 파일 처리 핸들러(모달 확인버튼 클릭시)
   *  엑셀 파일을 읽어서 이용자 정보 추가
   * blobUrl : 엑셀 파일 핸들링시 클라이언트에서 사용
   * blobUrl 없을 경우 모달 표시
   * @param blobUrl
   * @returns
   */
  const handleClickExcelLoad = async (blobUrl?: string) => {
    try {
      if (!blobUrl) {
        return setBaseModal({
          isOpen: true,
          title: "오류 발생",
          btnRightTitle: "확인",
          children: "엑셀 파일을 처리하는 중 오류가 발생했습니다.",
        });
      }
      const response = await fetch(blobUrl);
      const buffer = await response.arrayBuffer();
      const workbook = xlsx.read(buffer, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      console.log("worksheet", worksheet);
      // 엑셀 데이터 범위 설정
      const range = xlsx.utils.decode_range(worksheet["!ref"] || "");
      // B8의 위치 (8행부터 시작)
      const startRow = 7; // 0-indexed → 8번째 행 = index 7
      const startCol = 1; // B열 = index 1

      // 마지막 행/열까지 포함한 범위로 재설정
      const newRange = {
        s: { r: startRow, c: startCol },
        e: { r: range.e.r, c: range.e.c },
      };
      const rangeStr = xlsx.utils.encode_range(newRange);
      const json = xlsx.utils.sheet_to_json(worksheet, {
        // 엑셀 열 매핑 (B열: 타입, C열: 데이터)
        header: ["invitationType", "inviteData"],
        // 8번째 행부터 B열에서 시작
        range: rangeStr,
        // 원본 값 그대로 사용 (날짜나 숫자를 변환하지 않음)
        raw: true,
        // 빈 행 포함
        blankrows: false,
      });

      // 유효성 검사
      const errorCaseList: string[] = [];

      // 최대 이용자 수 체크
      if (formUserList.length + json.length > 100) {
        errorCaseList.push("이용자는 100명을 초과할 수 없습니다.");
      }

      if (json === undefined || json.length === 0) {
        errorCaseList.push("추가할 이용자가 없습니다. ");
      }

      // 각 이용자 정보 유효성 검사
      json.forEach((obj: any) => {
        // invitationType 유효성 검사 (B열)
        if (
          !obj.invitationType ||
          !(
            obj.invitationType?.toString().replaceAll(" ", "")?.toLowerCase() === "phone" ||
            obj.invitationType?.toString().replaceAll(" ", "")?.toLowerCase() === "email"
          )
        ) {
          errorCaseList.push("B열을 확인하세요.");
        }
      });

      const newErrorCaseList = [...new Set(errorCaseList)];

      // 에러 발생 시 모달 표시
      if (errorCaseList.length > 0) {
        return setBaseModal({
          isOpen: true,
          title: "파일을 업로드할 수 없습니다.",
          btnRightTitle: "확인",
          children: (
            <div style={{ wordBreak: "break-all" }}>
              <div className="font14 text-primary3 pre-formatted keep-all">{"아래의 내용을 확인 후 다시 시도해주세요."} </div>
              {/* 에러 리스트 전달하면 불릿으로 표시 */}
              <div className="w-100 text-left py10 px15 mt20 overflow-scroll text-primary" style={{ backgroundColor: "#F2F4F6", maxHeight: 250 }}>
                <ul style={{ listStyle: "none" }}>
                  {newErrorCaseList.map((item, idx) => (
                    //마지막 리스트는 마진 없음
                    <li key={idx} className={clsx({ mb5: idx !== newErrorCaseList.length - 1 })}>
                      • {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ), // 중복제거
        });
      }

      // 위애서 유효성 검사 통과 시 이용자 정보 추가
      json.forEach((obj: any) => {
        const invitationType = obj.invitationType?.toString().replaceAll(" ", "")?.toLowerCase() || "";
        const inviteData = obj.inviteData ? String(obj.inviteData) : "";

        const userInfo: UserFormData["users"][0] = {
          status: "READY",
          invitationType: invitationType === "email" ? "email" : "phone",
          inviteMobileNumber: invitationType === "email" ? "" : inviteData,
          inviteEmail: invitationType === "email" ? inviteData : "",
        };

        append(userInfo);
      });

      setAbstractModalZ1({ isOpen: false });
    } catch (error) {
      console.error("엑셀 파일 처리 중 오류 발생:", error);
      setBaseModal({
        isOpen: true,
        title: "오류 발생",
        btnRightTitle: "확인",
        children: "엑셀 파일을 처리하는 중 오류가 발생했습니다.",
      });
    }
  };

  return (
    <article className="contents-container__wrap-article">
      {/* 이용자 정보 섹션 헤더 */}
      <BaseSectionTitle
        title={"초대할 이용자"}
        noHashLink={true}
        className="pb10"
        rightArea={
          isAuthority("w") && (
            <div className="d-flex gap10">
              <BaseButton
                title="엑셀 업로드"
                disabled={formUserList.length >= 100}
                className="color-white icon-excel"
                onClick={() =>
                  setAbstractModalZ1({ isOpen: true, size: "medium", children: <ExcelUploadModal handleClickExcelLoad={handleClickExcelLoad} /> })
                }
              />
              <BaseButton title="개별 추가" disabled={formUserList.length >= 100} onClick={handleClickAddButton} />
            </div>
          )
        }
      />
      <div className="flex-row flex-start-start pb20">
        <p className="text-primary3 font14">{BULLET} 최대 100명까지 가능합니다.</p>
      </div>

      {/* 이용자 정보 테이블 */}
      {formUserList && (
        <div>
          <SpaceBaseTable
            data={formUserList || []}
            columns={userAddColumns}
            useFormReturn={useFormReturn}
            control={control}
            remove={remove}
            className="max-height700"
            formUserList={formUserList}
          />
          {/* 전체 삭제 버튼 등록페이지만 */}
          <div className="pt20 flex-center-end">
            <BaseButton
              title="전체 삭제"
              disabled={formUserList.length <= 0}
              className="color-white icon-trash"
              onClick={() => {
                setBaseModal({
                  isOpen: true,
                  title: "입력한 이용자 정보를 전체 삭제하시겠습니까?",
                  btnRightTitle: "확인",
                  btnLeftTitle: "취소",

                  onClose: () => {
                    setBaseModal({ isOpen: false });
                  },
                  onClick: () => {
                    setBaseModal({ isOpen: false });
                    setTimeout(() => {
                      remove();
                      //setBaseModal 과 함께 사용시 비정상 동작으로 setTimeout 사용
                      //이용자 목록 모두 삭제
                    }, 0);
                  },
                });
              }}
            />
          </div>
        </div>
      )}
    </article>
  );
};

export default UserInfo;
